import { render, staticRenderFns } from "./LoanTip.vue?vue&type=template&id=54785c7f&scoped=true"
import script from "./LoanTip.vue?vue&type=script&lang=js"
export * from "./LoanTip.vue?vue&type=script&lang=js"
import style0 from "./LoanTip.vue?vue&type=style&index=0&id=54785c7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54785c7f",
  null
  
)

export default component.exports